import { render } from "./AvaliacoesGoogle.vue?vue&type=template&id=ca4f7588&scoped=true&ts=true"
import script from "./AvaliacoesGoogle.vue?vue&type=script&lang=ts"
export * from "./AvaliacoesGoogle.vue?vue&type=script&lang=ts"

import "./AvaliacoesGoogle.vue?vue&type=style&index=0&id=ca4f7588&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4f7588"]])

export default __exports__